module.exports = __webpack_public_path__ + "assets/cb27c52e27a18ef6e2015439a8dd7eae.png";